export enum CallMaskingReferenceModelNameEnum{
    ONE_MEAL_SERVICE = "ONE_MEAL_SERVICE",
    TRIAL = "TRIAL",
    CHEF_FOR_PARTY = "CHEF_FOR_PARTY",
    SUBSCRIPTION = "SUBSCRIPTION"
}